module.exports = __webpack_public_path__ + "img/stripe.ce1827cc.png";